import React from "react";

const PanCard = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            fillRule="evenodd"
            d="M9.806 11.71A4.831 4.831 0 0 1 13.2 10.32c1.273 0 2.494.5 3.394 1.389.9.889 1.406 2.094 1.406 3.352a4.71 4.71 0 0 1-1.406 3.352 4.83 4.83 0 0 1-3.394 1.388 4.83 4.83 0 0 1-3.394-1.388A4.711 4.711 0 0 1 8.4 15.062c0-1.258.506-2.463 1.406-3.352ZM13.2 13.48a1.61 1.61 0 0 0-1.131.463 1.57 1.57 0 0 0 0 2.235 1.61 1.61 0 0 0 2.262 0 1.57 1.57 0 0 0 0-2.235 1.61 1.61 0 0 0-1.131-.463Z"
            clipRule="evenodd"
        />
        <path className="u_fill"
            fill={fill}
            d="M22.8 10.321c-.884 0-1.6.707-1.6 1.58 0 .873.716 1.58 1.6 1.58H26c.884 0 1.6-.707 1.6-1.58a1.59 1.59 0 0 0-1.6-1.58h-3.2ZM21.2 18.222c0-.873.716-1.58 1.6-1.58H26c.884 0 1.6.707 1.6 1.58a1.59 1.59 0 0 1-1.6 1.58h-3.2a1.59 1.59 0 0 1-1.6-1.58ZM10 22.963c-.884 0-1.6.707-1.6 1.58 0 .873.716 1.58 1.6 1.58h16c.884 0 1.6-.707 1.6-1.58a1.59 1.59 0 0 0-1.6-1.58H10Z"
        />
        <path className="u_fill"
            fill={fill}
            fillRule="evenodd"
            d="M3.875 5.851A6.44 6.44 0 0 1 8.4 4h19.2a6.44 6.44 0 0 1 4.526 1.851A6.282 6.282 0 0 1 34 10.321v15.803a6.282 6.282 0 0 1-1.874 4.47 6.44 6.44 0 0 1-4.526 1.85H8.4a6.44 6.44 0 0 1-4.525-1.85A6.282 6.282 0 0 1 2 26.123V10.32c0-1.676.674-3.284 1.875-4.47ZM8.4 7.161a3.22 3.22 0 0 0-2.263.925 3.14 3.14 0 0 0-.937 2.235v15.803c0 .838.337 1.642.937 2.234a3.22 3.22 0 0 0 2.263.926h19.2a3.22 3.22 0 0 0 2.263-.926 3.14 3.14 0 0 0 .937-2.235V10.322a3.14 3.14 0 0 0-.937-2.235A3.22 3.22 0 0 0 27.6 7.16H8.4Z"
            clipRule="evenodd"
        />
    </svg>
);

export default PanCard;